import {faPeriod} from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

import {classNames} from '../../util/css';

import * as styles from './form-active-mark.scss';

type PropsType = {
    className?: string;
    isVisible: boolean;
};

export function FormActiveMark(props: PropsType): JSX.Element | null {
    const {className, isVisible} = props;

    if (!isVisible) {
        return null;
    }

    return <FontAwesomeIcon className={classNames(styles.Mark, className)} icon={faPeriod} />;
}
